<template>
  <b-container fluid>
    <RpmClassificationList/>
  </b-container>
</template>

<script>
import RpmClassificationList from './List';

export default {
  name: 'RpmClassificationIndex',
  components: { RpmClassificationList },
  data() {
    return {
      breadcrumb: [
        {
          text: 'Dashboard',
          href: '/home',
        },
        {
          text: 'Master',
          href: '#',
        },
        {
          text: 'RPM Classification',
          active: true,
        },
      ],
    };
  },
  mounted() {
    this.$store.commit('breadcrumb/set_breadcrumb', this.breadcrumb);
  },
};
</script>
